<template>
    <div>
        <!-- Confirmação de Marcação -->
        <div class="modal fade" id="confirmacaoMarcacaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ confirm_tipo == 'C' ? 'Confirmar Marcação' : 'Sem Resposta' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="confirm_marcacao">
                            <div class="row">
                                <div class="col col-12" :class="soconfirmar ? '' : 'col-md-6'">
                                    <div class="row">
                                        <div class="col col-12">
                                            <h4 v-if="confirm_marcacao && confirm_marcacao.paciente">
                                                {{ confirm_marcacao.paciente.st_nome }}
                                            </h4>

                                            <h4 v-else-if="confirm_marcacao && confirm_marcacao.cadastro_temporario">
                                                {{ confirm_marcacao.cadastro_temporario.st_nome }}
                                            </h4>

                                            <az-input label="Observação" type="textarea" :validate="validate" v-model="confirm_obs" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col col-12">
                                            <ul class="list-group mt-2">
                                                <li class="list-group-item" v-for="(hist, ih) in confirm_marcacao.historico_status_marcacaos" :key="ih">
                                                    <div>
                                                        {{ $util.getFormatDate(hist.dt_mudanca_status) }}
                                                        {{ hist.dt_mudanca_status.substr(11,5) }}
                                                        <span class="text-muted" v-if="hist.usuario">por {{ hist.usuario.st_login }}</span>
                                                        <span class="badge badge-secondary ml-2">{{ hist.status_marcacao.st_status }}</span>
                                                    </div>
                                                    <div>
                                                        <small class="text-muted">{{ hist.st_observacao }}</small>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-12 col-md-6" v-if="!soconfirmar">
                                    <template v-if="outras_ordenadas && outras_ordenadas.length">
                                        <procedimentos-solicitados :listOnly="true" v-model="outras_ordenadas" />
                                    </template>

                                    <template v-else>
                                        <procedimentos-solicitados :listOnly="true" :value="[confirm_marcacao]" />
                                    </template>

                                    <div class="mt-3">
                                        <!-- 
                                        <az-instrucoes ref="instruc_conf" />
                                        -->
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer" v-if="confirm_marcacao">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit :color="confirm_tipo == 'C' ? 'success' : 'danger'" @click="confirmar_salvar()">
                            {{ confirm_tipo == 'C' ? 'Confirmar' : 'Sem Resposta' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import AzSubmit from "../../util/AzSubmit.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import ProcedimentosSolicitados from './ProcedimentosSolicitados.vue';

export default {
    data() {
        return { 
            confirm_tipo: "C",
            confirm_marcacao: null, 
            validate: false, 
        };
    },

    props: ['soconfirmar'],

    components: { 
        AzSubmit, 
        AzInput,
        ProcedimentosSolicitados,
    },

    computed: { 
        outras_ordenadas: { 
            get () { 
                if ( !this.confirm_marcacao || !this.confirm_marcacao.outras_marc ) { 
                    return [];
                }

                return _.orderBy(this.confirm_marcacao.outras_marc, 'dt_inicio');
            },
            set (dado) { 
                console.log(dado);
            }
        }
    },

    methods: { 
        abrir (marcacao, tipo = 'C') { 
            this.confirm_tipo = tipo;
            this.confirm_marcacao = marcacao;

            $('#confirmacaoMarcacaoModal').modal('show');
        },

        confirmar_salvar() {
            this.$util.atualizar(this, { 
                service: "marcacoes",
                func: "confirmar",
                dados: { 
                    id: this.confirm_marcacao.id_marcacao,
                    status: this.confirm_tipo,
                    obs: this.confirm_obs,
                    outras: this.confirm_marcacao.outras_marc ? this.confirm_marcacao.outras_marc.map(item => item.id_marcacao) : [],
                    status_marcacao: this.confirm_marcacao.ch_estado_marcacao,       
                },
                modal: 'confirmacaoMarcacaoModal',
                callback: () => { 
                    this.confirm_marcacao.status_confirmacao = 'Confirmada';
                    this.$emit('refresh');
                }
            });
        }

    }
}
</script>
